import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../../assets/img/reference.jpg'


const _hoisted_1 = { class: "_heading-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: _normalizeClass(_ctx.$style.modal),
    visible: _ctx.helperType,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.helperType) = $event)),
    modal: true,
    draggable: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_Toolbar, { class: "p-4" }, {
          left: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings_page.demo_result')), 1)
            ])
          ]),
          right: _withCtx(() => [
            _createVNode(_component_Button, {
              onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('close')),
              class: "p-button-outlined p-button-gray p-button-rounded p-button-only-icon"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, { name: "close" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.helperWrap, "px-4 pb-5 flex"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.helperBox)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.helperTitle)
            }, _toDisplayString(_ctx.$t('before')), 3),
            _hoisted_2
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.helperBox)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.helperTitle)
            }, _toDisplayString(_ctx.$t('after')), 3),
            _createElementVNode("img", {
              src: _ctx.helperImage[_ctx.helperType!],
              alt: ""
            }, null, 8, _hoisted_3)
          ], 2)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["class", "visible"]))
}